/** @jsxImportSource react */
import { useState } from 'react'
import { Alert, Box, Stack, Tab, Tabs, Typography } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { approvalsAPI } from '../api/crm'
import { useTenantKey } from '../hooks/useCrmQueries'
import { getErrorMessage } from '../utils/apiErrors'
import PageHeader from '../components/common/PageHeader'
import Loading from '../components/common/Loading'
import ApprovalCard from '../components/process/ApprovalCard'

/** Approvals waiting for me, and the ones I asked for. */
const ApprovalsPage = () => {
  const tenantId = useTenantKey()
  const [box, setBox] = useState('inbox')
  const { data = [], isLoading, error } = useQuery({ queryKey: [tenantId, 'approvals', box], queryFn: () => approvalsAPI.list(box) })
  return (
    <Box sx={{ maxWidth: 760 }}>
      <PageHeader title="Approvals" subtitle="Stage changes that need someone’s OK before they happen." />
      <Tabs value={box} onChange={(_, b) => setBox(b)} sx={{ mb: 2 }}>
        <Tab value="inbox" label="Waiting for me" />
        <Tab value="mine" label="I asked" />
      </Tabs>
      {error && <Alert severity="error">{getErrorMessage(error)}</Alert>}
      {isLoading ? <Loading /> : data.length === 0 ? (
        <Typography color="text.secondary">{box === 'inbox' ? 'Nothing waiting for you.' : 'You haven’t asked for any approvals.'}</Typography>
      ) : (
        <Stack spacing={1.5}>{data.map((a) => <ApprovalCard key={a.id} a={a} showRecord />)}</Stack>
      )}
    </Box>
  )
}

export default ApprovalsPage
